<p-panel header="Fehler">
  <p>
    <i class="pi pi-exclamation-triangle"></i> Fehler: Die Seite konnte nicht
    gefunden werden.
  </p>
</p-panel>
